module.exports = __webpack_public_path__ + "img/84.0dbfd5b5.png";